// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_2hKPQ6OLA9","icon":"_2ZKJdTa57R","divider":"_3ebFDBdOir"};
    if(module.hot) {
      // 1614934693767
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  